import { CodePreview } from '@/components/CodePreview';
import { DetailsSection } from '@/components/SectionWithCard';

type CodeViewParams = {
  rawCode?: string | null;
  compiledCode?: string | null;
};

export const CodeView = ({ rawCode, compiledCode }: CodeViewParams) => {
  if (!rawCode) return null;
  return (
    <>
      <DetailsSection className="mt-4" isCompact>
        <div className="mt-4 px-10 pb-6">
          <CodePreview source={rawCode} compiled={compiledCode || undefined} />
        </div>
      </DetailsSection>
    </>
  );
};
